// The RTMP server destination icon is just the material dns icon
import Dns from "~/components/MaterialIcons/Dns";
export default Dns;
